import { FC } from "react";
import { PageWrapper } from "@connectedComponents";
import { stackEnum } from "@utilities/enums";
import { useController } from "./useController";
import { AddClientForm, Button, Card, GenericActionsBar, Icon, Modal } from "@components";
import { ClientCard } from "./components";

export const ClientsManagement: FC = () => {

    const { 
        clientsFiltered, isAddClientModalOpen,
        setSearchClient, goBack, onDeleteClient,
        onToggleAddClientModal, handleEditClient,
        handleCreateClient,
    } = useController();

    return (
        <PageWrapper
            activeStack={stackEnum.stocksStack}
            handleGoBack={goBack}
        >
            <Card
                title="Gestion des clients"
                actions={
                    <GenericActionsBar
                        searchPlaceholder="Rechercher un client..."
                        handleSearch={setSearchClient}
                        customActions={[
                            <Button
                                variant='info'
                                onClick={onToggleAddClientModal}
                            >
                                <Icon iconName="UserRoundPlus" size={20} /> Ajouter un client
                            </Button>
                        ]}
                    />
                }
            >
                <div className="mt-4">
                    {
                        clientsFiltered.length > 0 ? (
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {
                                    clientsFiltered.map((client, i)=> (
                                        <ClientCard 
                                            key={i}
                                            client={client}
                                            onEdit={handleEditClient}
                                            onDelete={onDeleteClient}
                                        />
                                    ))
                                }
                            </div>
                        ) : (
                            <div className="flex justify-center items-center h-full">
                                <p className="text-gray-500">Aucun client trouvé</p>
                            </div>
                        )
                    }
                </div>
            </Card>
            
            <Modal
                isOpen={isAddClientModalOpen}
                onClose={onToggleAddClientModal}
                title="Ajouter un client"
            >
                <AddClientForm 
                    onCreateClient={handleCreateClient}
                    onCancel={onToggleAddClientModal}
                />
            </Modal>
        </PageWrapper>
    );
};
